import { createAsyncThunk } from '@reduxjs/toolkit';
import { minesiderBackendService } from 'app/api/service/minesider-backend-service';
import { addToastMessage } from './toast-message-actions';
import { i18n } from 'app/i18n/i18n';

export const getInsuranceDocument = createAsyncThunk(
  'documents/insurance/getPdf',
  (customerCrmId: string, thunkApi) => {
    const pdfLinkDocumentFileName = `${i18n.t('pages.security.insurance.pdfLinkDocumentFileName')}.pdf`;
    const invoicePdfResponse = minesiderBackendService.getInsuranceDocument(customerCrmId);
    invoicePdfResponse
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', pdfLinkDocumentFileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        thunkApi.dispatch(
          addToastMessage({
            heading: i18n.t('pages.security.insurance.pdfLinkDownloading'),
            alertType: 'success',
            role: 'alert',
          }),
        );
      })
      .catch(() => {
        thunkApi.dispatch(
          addToastMessage({
            heading: i18n.t('pages.security.insurance.pdfLinkFailed'),
            alertType: 'warning',
            role: 'alert',
          }),
        );
      });
    return invoicePdfResponse;
  },
);
